<template>
    <div>
        <div class="lists-setting-container">
            <div class="header-container">
                <h4><font-awesome-icon icon="fa-solid fa-list-ul" size="sm" style="color: #000;" />System Lists</h4>
            </div>
            <el-tabs :tab-position="tabPosition"  class="demo-tabs">
                <el-tab-pane label="Bedrooms">
                    <el-table 
                    :row-class-name="tableRowClassName"
                    v-loading="false" element-loading-text="Loading..." 
                    element-loading-background="rgba(255, 255, 255, 0.8)" 
                    :data="[{name:'1'},{name:'2'},{name:'3'},{name:'4'},{name:'5'},{name:'6'}]" 
                    style="width: 100%" 
                    :header-row-class-name="'table-header-style'" 
                    :header-cell-class-name="'table-header-cell-style'" 
                    :highlight-current-row="true" 
                    :cell-class-name="'custom-cell'">

                        <el-table-column 
                            label="Name" 
                            prop="name"
                            
                        >
                        </el-table-column>
                        

                        
                        
                        
                        
                        
                        <el-table-column align="center" fixed="right" width="150">
                            <template #header>
                                Actions
                            </template>
                            <template #default="scope">

                                <el-button
                                    size="small"
                                    type="danger"
                                    :icon="Delete" 
                                    circle
                                    @click="deleteProject(scope.row.id)"
                                    
                                />

                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="Bathrooms">Bathrooms</el-tab-pane>
                <el-tab-pane label="Levels">Levels</el-tab-pane>
                <el-tab-pane label="Property type">Property type</el-tab-pane>
                <el-tab-pane label="Areas">Areas</el-tab-pane>
                <el-tab-pane label="Services">Services</el-tab-pane>
                <el-tab-pane label="Finishings">Finishings</el-tab-pane>
                <el-tab-pane label="Video">Video</el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>



<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  ArrowRight,
  CaretBottom,
  CaretTop,
  Check,
  Warning,
  Delete,
  Edit,
  Close,
  Search ,
  View,
} from '@element-plus/icons-vue'
export default {
  components: {  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const tabPosition = ref('top');
    return {
        tabPosition,
        router,
        store,
        Delete
    }
  }
};
</script>

<style lang="scss">
.lists-setting-container{
    background-color: rgb(205, 228, 255);
    padding: 15px;
    border-radius: 10px;
    margin-top: 20px;
    .header-container{
        margin-bottom: 15px;
        h4{
            font-weight: normal;
            display: flex;
            align-items: center;
            svg{
                margin-right: 5px;
            }
        }
    }
}
</style>